import React, { useEffect, useState } from 'react';
import { useFormContext } from '../context/FormContext';
import { Receipt } from '../../Receipt/Receipt';
import { PollDialog } from '../../PollDialog/PollDialog';
import { donateEvent } from '@kuow/core';

export const ReceiptStep: React.FC = () => {
  const { state } = useFormContext();
  const { receipt } = state;
  const pollId = receipt?.pollId;
  const [shouldRenderPollDialog, setShouldRenderPollDialog] = useState(false);

  useEffect(() => {
    donateEvent('Step Confirmation', state.placement);
  }, [state.placement]);

  useEffect(() => {
    if (shouldRenderPollDialog) return;
    if (!receipt) return;
    if (pollId === null || pollId === undefined) return;

    const timeoutId = window.setTimeout(() => {
      setShouldRenderPollDialog(true);
    }, 3000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [pollId, receipt, shouldRenderPollDialog]);

  if (!receipt) {
    return null;
  }

  return (
    <>
      <Receipt receiptData={receipt} mode={state.mode} hadActiveChallenge={Boolean(state.formDetails?.matching_challenge)} placement={state.placement} />
      {shouldRenderPollDialog && pollId !== null && pollId !== undefined ? (
        <PollDialog pollId={pollId} memberId={receipt.memberId} donationId={receipt.donationId} />
      ) : null}
    </>
  );
};

